var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extraItem.extras('nav.display'))?_c('div',{staticClass:"m-header",style:({
    height: _vm.pxOrVw(_vm.extraItem.extras('nav.model')),
  })},[_c('div',{staticClass:"header-inner"},[(_vm.extraItem.extras('logo.display'))?_c('a',{staticClass:"logo",class:_vm.extraItem.extras('logo.size'),style:({
        cursor: _vm.extraItem.extras('logo.href') ? 'pointer' : 'default',
      }),attrs:{"href":_vm.extraItem.extras('logo.href')
          ? _vm.extraItem.extras('logo.href')
          : 'javascript:;'}},[_c('img',{attrs:{"src":_vm.extraItem.extras('logo.src'),"alt":""}})]):_vm._e()])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }